import Vue from 'vue';
import helpers from "./mixins/helpers";
if(document.getElementById('create-certificate')){

    $(document).ready(function() {

        var $specializationNode = $("#specialization");

        $specializationNode.select2({
            theme: 'select-city',
            placeholder: "Введите специализацию",
            allowClear: false,
            doReset:false,
            doToggle:false,
            doOrder:false
        });

        $specializationNode
            .on("select2:select", function(e) {
                createCertificate.specialization= {
                    id:$(this).val(),
                    text:$(this).find('option:selected').text()
                };
                createCertificate.fetchSections();
            });
    });

    let createCertificate = new Vue({
        mixins: [helpers],
        el:"#create-certificate",
        data:{
            specialization:null,
            section:null,
            sections:null,
            lections:null,
            load:false,
            lectionChecked:[],
            calcMessage:'0 вебинаров, 0 часов'
        },
        mounted() {
            if($("#specialization").val() > 0){
                this.specialization = {
                    id:$("#specialization").val(),
                    text:$("#specialization option:selected").text()
                };

                this.fetchSections();

            }

        },
        methods:{
            fetchSections() {
                let self = this;
                this.load = true;
                $.ajax({
                    url:'/user/certificate/get-sections/'+self.specialization.id,
                    type: "POST",
                    data: {
                        _csrf:self.getCsrf()
                    },
                    success:function(response){
                        self.sections = response;
                        self.load = false;
                    }
                });
            },
            setSection(section){

                let self = this;
                this.load = true;
                this.section = section;
                $.ajax({
                    url:'/user/certificate/get-lections/'+self.section,
                    type: "POST",
                    data: {
                        _csrf:self.getCsrf()
                    },
                    success:function(response){
                        self.lections = response;
                        self.load = false;
                        $('.choice-cer').slideUp("slow");
                        $('.change-profile').css('display', 'block');
                        $("html, body").animate({ scrollTop: 0 }, 600);
                    }
                });
            },
            countCertificates(section){
                return this.sections[section].certificates + ' ' + this.decOfNum(this.sections[section].certificates, ['сертификат выдан', 'сертификата выдано', 'сертификатов выдано']);

            },
            changeSection(){
                this.section = null;
                this.lectionChecked = [];
                $('.change-profile').slideUp("slow");
                $('.choice-cer').slideDown("slow");
                $("html, body").animate({ scrollTop: 0 }, 600);
            },
            calcCertificate(){
                if(this.lectionChecked.length > 5){

                    this.lectionChecked.shift();

                }
                let hours = this.lectionChecked.length * 3;
                let calcMessage = this.lectionChecked.length + ' ' + this.decOfNum(this.lectionChecked.length, ['вебинар', 'вебинара', 'вебинаров']);

                calcMessage += ', '+ hours + ' ' + this.decOfNum(hours, ['час', 'часа', 'часов']);

                this.calcMessage = calcMessage;
            },
            createCertificate(){
                let self = this;
                this.load = true;
                $.ajax({
                    url:'/user/certificate/new',
                    type: "POST",
                    data: {
                        passedLections:self.lectionChecked,
                        sectionId: self.section,
                        _csrf:self.getCsrf()
                    },
                    success:function(response){
                        if(response === true){
                            location.href = '/user/certificate';
                        }
                    }
                });
            }
        }

    });

}